import React from 'react';
import Lottie from 'react-lottie';
import TMNLoaderAnimate from '../../../assets/loader.json';
import './loader.css';
import TMNLoader from '../../../assets/images/ic-home-01@2x.png';

interface Props {
    isAnimate?: boolean;
}

const PageLoader: React.FC<Props> = ({ isAnimate = true }) => {
    return (
        <div className="loader__container">
            {isAnimate ? (
                <Lottie
                    options={{
                        loop: true,
                        autoplay: true,
                        animationData: TMNLoaderAnimate,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid slice',
                        },
                    }}
                    height={96}
                    width={96}
                    isStopped={false}
                    isPaused={false}
                />
            ) : (
                <img height={60} src={TMNLoader} alt="tmn loader" />
            )}
        </div>
    );
};

export default PageLoader;
